import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';

const Tab = ({ id, title, selected, className, data, onClick }) => {
  className = `tabs--item ${className}`;
  return (
    <li
      className={selected ? `${className} active` : className}
      data-info={data}
      onClick={onClick}
    >
      <FormattedHTMLMessage id={id} defaultMessage={title}/>
    </li>
  );
};

Tab.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.string,
  onClick: PropTypes.func,
};

export default Tab;
